"use client";

import { DepartmentsSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedDepartmentsSection from "../Components/GeneratedDepartmentsSection";

const Departments: FC<DepartmentsSectionProps> = (props) => {
  return <GeneratedDepartmentsSection {...props} />;
};

export default Departments;
